import { $http } from '@/utils/https'

export default {
	name	: 'download-certificate-button',
	props	: {
		course		: {},
		userCourse	: {},
	},
	data() {
		return {
			fetchedCertificateLink	: null,
		}
	},
	methods	: {
		pointAFlag() {
			const uc = this.userCourse
			
			if (!uc || typeof uc !== 'object') {
				return false
			}
			
			return uc.isPointAFilled !== undefined
				? uc.isPointAFilled === true
				: uc.is_point_a_filled === true
		},
		pointBFlag() {
			const uc = this.userCourse

			if (!uc || typeof uc !== 'object') {
				return false
			}

			// Admin diploma override bypasses the Point B gate for this enrolment.
			if (uc.pointBOverride === true || uc.point_b_override === true) {
				return true
			}

			return uc.isPointBFilled !== undefined
				? uc.isPointBFilled === true
				: uc.is_point_b_filled === true
		},
		async fetchDiplomaPdfLink() {
			if (!this.course || !this.course.slug) {
				return null
			}
			
			const { data } = await $http.get(
				`${process.env.VUE_APP_ROOT_COURSE}my/courses/${this.course.slug}/certificate/pdf`
			)
			
			const link = data && data.link ? data.link : null
			
			if (link) {
				this.fetchedCertificateLink = link
			}
			
			return link
		},
		async onDiplomaClick(e) {
			e.preventDefault()
			
			if (!this.enabled) {
				return
			}
			
			if (!this.pointAFlag()) {
				this.$emit('open-point-a')
				
				return
			}
			
			if (!this.pointBFlag()) {
				this.$emit('open-point-b')
				
				return
			}
			
			const existing =
				(this.userCourse.userCertificate &&
					this.userCourse.userCertificate.data &&
					this.userCourse.userCertificate.data.link) ||
				this.fetchedCertificateLink
			
			if (existing) {
				window.open(existing, '_blank')
				
				return
			}
			
			const link = await this.fetchDiplomaPdfLink()
			
			if (link) {
				window.open(link, '_blank')
			}
		},
	},
	computed	: {
		enabled() {
			const hasServerLink =
				this.userCourse &&
				this.userCourse.userCertificate &&
				this.userCourse.userCertificate.data &&
				this.userCourse.userCertificate.data.link
			
			return (this.visible && this.enoughtPoints) || this.fetchedCertificateLink || hasServerLink
		},
		enoughtPoints() {
			return this.scoredPoints >= this.requiredPoints && this.requiredPoints > 0
		},
		visible() {
			return (
				this.course &&
				this.course.certificates &&
				this.course.certificates.data &&
				this.course.certificates.data.length > 0
			)
		},
		activityClass() {
			const uc = this.userCourse
			const noCert =
				!uc ||
				uc.userCertificate === undefined ||
				uc.userCertificate.data.length == 0
			
			return noCert && !this.enabled ? 'disabled' : 'active'
		},
		scoredPoints() {
			if (!this.userCourse) {
				return 0
			}
			
			return this.userCourse.scoredPoints
		},
		requiredPoints() {
			if (
				!this.course ||
				!this.course.certificates ||
				!this.course.certificates.data ||
				!this.course.certificates.data.length
			) {
				return 0
			}
			
			return this.course.certificates.data[0].points
		},
		downloadLink() {
			if (
				this.userCourse.userCertificate &&
				this.userCourse.userCertificate.data &&
				this.userCourse.userCertificate.data.link
			) {
				return this.userCourse.userCertificate.data.link
			}
			
			return this.fetchedCertificateLink || '#'
		},
	},
	mounted() {
		// PDF за запитом у onDiplomaClick після заповнення Point A / Point B
	},
}
